import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { endpointsURL } from "../constants/endpointsURL";

@Injectable({
  providedIn: "root",
})
export class DataCdtService {
  env = environment.env;
  maintenanceDataCDTURL = endpointsURL.maintenanceDataCDTURL;

  constructor(private httpClient: HttpClient) {}

  public list(filters: string): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenanceDataCDTURL}/lista${filters}`
    );
  }

  public getOne(id: number): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.env}${this.maintenanceDataCDTURL}?_id=${id}`
    );
  }

  public createOne(dataCDT: any): Observable<any> {
    return this.httpClient.post<any>(
      `${this.env}${this.maintenanceDataCDTURL}`,
      dataCDT
    );
  }

  public updateOne(dataCDT: any): Observable<any> {
    return this.httpClient.put<any>(
      `${this.env}${this.maintenanceDataCDTURL}`,
      dataCDT
    );
  }
}
